import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { getIcon } from "@/lib/icons";

export default function Advantages({ content }) {
  const items = content.advantages;
  return (
    <section className="bg-navy-texture py-24" data-testid="advantages-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="[&_h2]:!text-white [&_p]:!text-slate-300 [&_span]:!text-slate-400">
          <SectionHeading
            number="04"
            eyebrow="Keunggulan"
            title="Mengapa Memilih Perumahan Cluster Kami?"
            description="Setiap kawasan yang kami kembangkan dirancang dengan mempertimbangkan kenyamanan dan kebutuhan keluarga."
          />
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((a, i) => {
            const Icon = getIcon(a.icon);
            return (
              <Reveal key={i} delay={(i % 4) * 0.08} className={i === 0 ? "sm:col-span-2" : ""}>
                <div
                  className="group h-full rounded-2xl border border-white/10 bg-white/5 p-6 transition-colors duration-300 hover:border-brand-sky/40 hover:bg-white/10 sm:p-7"
                  data-testid={`advantage-card-${i}`}
                >
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand/20 transition-colors duration-300 group-hover:bg-brand">
                    <Icon className="h-6 w-6 text-brand-sky transition-colors duration-300 group-hover:text-white" />
                  </div>
                  <h3 className="mt-5 font-display text-lg font-bold text-white">{a.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-300">{a.description}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
